export default __webpack_public_path__ + "static/media/logo_020823.d5a28410.svg";